import { create } from "zustand";

// Define interfaces for type safety
interface PaymentMethod {
  firstName: string;
  lastName: string;
  cardNumber: string;
  expiryMonth: string;
  expiryYear: string;
  cvv: string;
  country: string;
  city: string;
  id?: number;
}

interface PaymentStore {
  isPaymentModalOpen: boolean;
  paymentMethod: PaymentMethod;
  paymentMethods: PaymentMethod[];
  openPaymentModal: () => void;
  closePaymentModal: () => void;
  updatePaymentMethod: (updatedPayment: Partial<PaymentMethod>) => void;
  addPaymentMethod: (paymentMethod: PaymentMethod) => void;
  resetPaymentForm: () => void;
}

const usePaymentStore = create<PaymentStore>((set) => ({
  // Modal state
  isPaymentModalOpen: false,

  // Payment data
  paymentMethod: {
    firstName: "Esosa",
    lastName: "Chiejine",
    cardNumber: "",
    expiryMonth: "",
    expiryYear: "",
    cvv: "",
    country: "Nigeria",
    city: "",
  },

  // Payment methods list
  paymentMethods: [],

  // Actions
  openPaymentModal: () => set({ isPaymentModalOpen: true }),
  closePaymentModal: () => set({ isPaymentModalOpen: false }),

  updatePaymentMethod: (updatedPayment: Partial<PaymentMethod>) =>
    set((state) => ({
      paymentMethod: { ...state.paymentMethod, ...updatedPayment },
    })),

  addPaymentMethod: (paymentMethod: PaymentMethod) =>
    set((state) => ({
      paymentMethods: [
        ...state.paymentMethods,
        { ...paymentMethod, id: Date.now() },
      ],
    })),

  resetPaymentForm: () =>
    set((state) => ({
      paymentMethod: {
        ...state.paymentMethod,
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: "",
        city: "",
      },
    })),
}));

export default usePaymentStore;
